IntlMessageFormat.__addLocaleData({"locale":"tzm","pluralRuleFunction":function (n,ord){var s=String(n).split("."),t0=Number(s[0])==n;if(ord)return"other";return n==0||n==1||t0&&n>=11&&n<=99?"one":"other"}});
IntlMessageFormat.__addLocaleData({"locale":"tzm-Latn","parentLocale":"tzm"});
IntlMessageFormat.__addLocaleData({"locale":"tzm-Latn-MA","parentLocale":"tzm-Latn"});
